import axios from "axios"
import { rawInstance, tokenInstance } from "../baseApi"
import api_url from "../apiPaths"

// login call without tokenInstance

export const login = async (body) => {
  const response = await axios.post(`${api_url.loginUrl}/users/auth/login/`, body)
  return response
}

export const logout = async (body) => {
  const response = await axios.post(`${api_url.loginUrl}/users/auth/logout/`, body)
  return response
}

export const otpGenrate = async (body) => {
  try {
    const response = await axios.post(`${api_url.loginUrl}/users/otp-generation`, body)
    // console.log(response.data.data.result)
    return response
  } catch (error) {
    return error
    // console.error("Error fetching data:", error)
  }
}

export const otpVerify = async (body) => {
  try {
    const response = await axios.post(`${api_url.loginUrl}/users/otp-verification`, body)
    // console.log(response.data.data.result)
    return response
  } catch (error) {
    return error
    // console.error("Error fetching data:", error)
  }
}

export const passwordReset = async (body) => {
  try {
    const response = await axios.post(`${api_url.loginUrl}/users/change/password/`, body)
    // console.log(response.data.data.result)
    return response
  } catch (error) {
    return error
    // console.error("Error fetching data:", error)
  }
}

export const postUpdatePassword = async (body) => {
  try {
    const response = await tokenInstance.post(`${api_url.loginUrl}/users/forget/password/`, body)
    // console.log(response.data.data.result)
    return response
  } catch (error) {
    return error
    // console.error("Error fetching data:", error)
  }
}
export const getPublicApiKey = async (body) => {
  try {
    const response = await axios.get(`${api_url.base_url}/public-key/`, body)
    // console.log(response.data.data.result)
    return response
  } catch (error) {
    return error
    // console.error("Error fetching data:", error)
  }
}

export const refreshToken = async (body) => {
  const response = await axios.post(`${api_url.loginUrl}/users/auth/refresh/`, body)
  return response
}
